import type { ComponentProps } from "react"
import Sheet from "@/v2-ui/sheet"

export type ViewSheetTitleProps = ComponentProps<typeof Sheet.Title> & {
  isLoading?: boolean
}

function ViewSheetTitle(props: ViewSheetTitleProps) {
  const { isLoading, children, ...sheetTitleProps } = props
  return (
    <Sheet.Title {...sheetTitleProps}>
      {isLoading ? "Loading.." : children || "Unknown.."}
    </Sheet.Title>
  )
}

export default ViewSheetTitle
